import BaseModel from './BaseModel';

class PatientRecordFilterOption extends BaseModel {}

PatientRecordFilterOption.collection = 'PatientRecordFilterOptions';

export default PatientRecordFilterOption;
